import { app } from '../../../app';
import { Controller } from './profiles.controller';

app.component('userProfiles', {
    bindings: {account: '<', profiles: '<'},
    controller: Controller,
    templateUrl: require('./profiles.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profiles.component.js